  import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Item, itemKeys } from 'models/ItemModel';
import { Inventory, inventoryKeys } from 'models/InventoryModel';
import { CommonDataColumn } from 'models/BaseModel';
import AsyncSelect from 'react-select/async';
import { ItemInventory } from 'models/ItemInventoryModel';


const PurchaseItem: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.ITEM, Code.Form.Name.ITEM];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [controlOptions, setControlOptions] = Hooks.Form.OptionMore();
  const [formData, setFormData] = useState<ItemInventory>({});
  const [inventoryData, setInventoryData] = useState<CommonDataColumn>({});
  //const [inventoryId, setInventoryId] = useState<number | undefined>(Code.Option.Common.NA);
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    API.Data.GetByKeyId<ItemInventory>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.item_active); 
        //setInventoryId(data.inventory_id);
        Files.List.ParseCommonData(data.inventory_data, setInventoryData);
        const productName = await API.Data.GetProductName(data.product_id);
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
          product_name: Utility.Value.Text(productName), 
        }));
      }})
      setLoading(false);
  }, []);

  useEffect(()=>{
    const specificationId = formData.specification_id;
    if(specificationId && specificationId >=100){
        Files.Json.APIMore(Code.File.CONTROL+specificationId, Code.Option.Common.NOTHING, setControlOptions, setError);
    }
  },[formData.specification_id])

  // useEffect(()=>{
  //   const TYPE = inventoryData.TYPE;
  //   if(inventoryData.TYPE){
  //     if(TYPE){
  //       Files.Json.APIMore(Code.File.CONTROL+TYPE, Code.Option.Common.NOTHING, setControlOptions, setError);
  //     } 
  //   }
  // },[inventoryData.TYPE])


  useEffect(()=>{
    //console.log("FormData changed", formData);
  },[formData])

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    if (formData) {
      let grossAmount = formData.item_gross_amount || 0;
      let discountAmount = formData.item_discount_amount || 0;
      let taxableAmount = formData.item_taxable_amount || 0;
      if(discountAmount == 0){
        if(grossAmount != taxableAmount){
          discountAmount = Number(grossAmount) - Number(taxableAmount);
        }
      }

      const finalData = Utility.Sanitize.FormData({
        ...formData,
        inventory_data: JSON.stringify(Utility.Clean.Object(inventoryData)),
        item_discount_amount: discountAmount,
      });

      const localItemData = Utility.Get.ModelFields<Item>(finalData, itemKeys);
      const localInventoryData = Utility.Get.ModelFields<Inventory>(finalData, inventoryKeys);

      const itemId = formData.item_id?.toString();
      const inventoryId = formData.inventory_id?.toString();

      if(localItemData && localInventoryData && itemId && inventoryId){
        const response = await API.Data.SaveItemInventory(itemId, inventoryId, localItemData, localInventoryData);
        if(response){
          if(response['code']==200){
            Utility.Message.Info(["Item updated successfully"],setMessage);
            await Utility.Set.Delay(1000);
            Utility.Button.PopupClose();
          }
        }
      }
    }
  };

  useEffect(()=>{ CalculateValues(); },[
    formData.item_gross_amount,
    formData.item_discount_amount,
    formData.item_taxable_amount,
    formData.item_tax1_percentage,
    formData.item_tax1_amount,
    formData.item_net_amount,
  ])

  const CalculateValues = () => {
    let grossAmount = formData.item_gross_amount || 0;
    let discountAmount = formData.item_discount_amount || 0;
    let taxableAmount = formData.item_taxable_amount || 0;
    let taxPercentage = formData.item_tax1_percentage || 0;
    let taxAmount = formData.item_tax1_amount || 0;
    let netAmount = formData.item_net_amount || 0;

    if(grossAmount && grossAmount > 0) {
      if(discountAmount && discountAmount > 0) {
        taxableAmount = Number(grossAmount) - Number(discountAmount);
      }
    }
    
    if(taxableAmount && taxableAmount>0) {
      if(taxPercentage && taxPercentage>0) {
        taxAmount = (Number(taxableAmount) * Number(taxPercentage)) / 100;
      }
    }

    netAmount = taxableAmount;

    if(taxableAmount && taxableAmount> 0 && taxAmount && taxAmount>=0) {
      netAmount = Number(taxableAmount) + Number(taxAmount);
    }
    
    const saleAmount = Number(grossAmount) * 2.4;

    setFormData((prevData) => ({
      ...prevData,
      inventory_sale_price:  Utility.Calculate.roundOffBy5(saleAmount), 
      inventory_purchase_price: grossAmount, 
      inventory_cost_price: taxableAmount, 
      item_discount_amount: discountAmount,
      item_taxable_amount: taxableAmount,
      item_tax1_amount: taxAmount,
      item_net_amount: netAmount,
    }));
      
  }

  async function handleProductChange(product: OptionType | null ): Promise<void> {
    if (!product) return;
    const specificationId = await API.Data.SpecificationId(product.value);
    if (!specificationId) return;

    setFormData((prev: any) => ({
      ...prev,
      product_id: product.value,
      product_name: product.label,
      specification_id: specificationId, 
    }));

  }


  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Item Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Header id={Name.Product.Id} title={Title.Product} require={true}  size={[0,50,1]}>
                  <AsyncSelect id={Name.Product.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.PRODUCT, Code.Mapping.product.value, Code.Mapping.product.label)} styles={Code.Style.FormOption} onChange={(selected: OptionType | null) => handleProductChange(selected)} value={Utility.Value.Async(formData.product_id,formData.product_name)} placeholder="Search" isDisabled={false} />
                </Field.Header>
                <Field.Date id={Name.Item.Date} value={formData.item_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} currentDate={true} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Item.SKU} value={formData.item_skucode} title={Title.Skucode} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,33,1]} disabled={true} />
                <Field.Text id={Name.Inventory.SerialNo} value={formData.inventory_serialno} title={Title.Serial} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} />
                <Field.Amount id={Name.Inventory.Sale} value={formData.inventory_sale_price} title={"Sale Price"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,33,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Amount id={Name.Item.Gross} value={formData.item_gross_amount} title={"Wholesale"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,33,1]} require={true} />
                <Field.Amount id={Name.Item.DiscountA} value={formData.item_discount_amount} title={"Discount"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} require={true} />
                <Field.Amount id={Name.Item.Taxable} value={formData.item_taxable_amount} title={"Cost"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,33,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Number id={Name.Item.Tax1P} value={formData.item_tax1_percentage} title={"GST(%)"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,33,1]} require={true} />
                <Field.Amount id={Name.Item.Tax1A} value={formData.item_tax1_amount} title={"GST Amount"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} require={true} />
                <Field.Amount id={Name.Item.Net} value={formData.item_net_amount} title={"Net Amount"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,33,0]} require={true} />
              </Control.Row>
              {controlOptions.length > 0 ? <Field.Title title='Specifications'/> :'' }
              <Control.Box>
                {controlOptions.map((item, index) => (
                   <Field.Suggestion key={item.value ?? index} id={`D${item.value}`} value={Utility.Get.FieldValue(inventoryData, `D${item.value}` as keyof CommonDataColumn)} title={item.label} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)}  dataList={item.data1} horizontal={true} className='htext2' width={80} />
                ))}
              </Control.Box>
              <Control.Row>
                <Field.Area id={Name.Item.Comment} value={formData.item_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
            </Control.Tab.Content>

          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default PurchaseItem;